import React, { useEffect } from 'react';

import { assert } from '../base/utils/assert';

import Misc from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import ShareWidget, { ShareLink } from '../base/components/ShareWidget';
import { getType } from '../base/data/DataClass';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import C from '../C';
import ActionMan from '../plumbing/ActionMan';
import BrandingEditor from './BrandingEditor';

import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';
import KStatus from '../base/data/KStatus';
import { setWindowTitle } from '../base/plumbing/Crud';
import ListItems from './ListItems';
import { MondayLink } from './monday';
import LinkOut from '../base/components/LinkOut';
import XId from '../base/data/XId';
import { encURI } from '../base/utils/miscutils';
import { setNavContext } from '../base/components/NavBar';
import { getXeroContactUrl } from '../data/Xero';
import { Card } from '../base/components/CardAccordion';
import PropControlMoney from '../base/components/propcontrols/PropControlMoney';
import Money from '../base/data/Money';
import { Alert } from 'reactstrap';


function AgencyPage() {
	const type = C.TYPES.Agency;
	setWindowTitle(type);

	const blocked = Misc.CheckAccess({can: 'editAdvert'});
	if (blocked) return blocked;

	const path = DataStore.getValue(['location','path']);
	const agencyId = path[1];
	

	if ( ! agencyId) {
		return <ListItems type={type} base={{}} />;
	}
	const pvItem = ActionMan.getDataItem({type:C.TYPES.Agency, id:agencyId, status:KStatus.DRAFT});
	if ( ! pvItem.value) {
		return (<div><h1>Agency: {agencyId}</h1><Misc.Loading /></div>);
	}
	const item = pvItem.value;
	setWindowTitle(item);	

	useEffect(() => {
		setNavContext(type, agencyId, true);
		setNavContext(C.TYPES.Advert, null);
	}, [agencyId]);

	return (
		<div className=''>
			<h1>Agency: {item.name || agencyId}</h1>
			<EditAgency agency={item} />
		</div>
	);
} // ./AgencyPage



function EditAgency({agency}) {
	assert(agency, 'AgencyPage.jsx - no agency?! - if new, ListLoad create should take care of this');
	// HACK: patch malformed items
	if ( ! getType(agency)) agency['@type'] = C.TYPES.Agency;
	if ( ! agency.id) agency.id = C.newId;
	assert(agency.id, agency);	
	// render
	return (
		<div>
			<h3>{agency.id===C.newId? 'Register New Agency' : 'Edit Agency'}</h3>
			<EditAgencyForm agency={agency} />
			<ShareWidget item={agency} hasButton />
		</div>
	);
}

function EditAgencyForm({agency}) {
	assert(agency.id, agency);
	let path = getDataPath({status:KStatus.DRAFT, type:C.TYPES.Agency, id:agency.id});
	// TODO <PartnerControlSummary item={agency} /> currently done via Adverts
	// 			<CharityControls entity={agency} /> done via Adverts
	// NB Brand name has class "brand-name" to make it unambiguously selectable in tests, do not remove
	return (
		<div className="form">
			ID: {agency.id}<br />
			<MondayLink item={agency} path={path} type="Agency" board="2559728405" />
			
			<PropControl className="brand-name" label="Agency Name" item={agency} path={path} prop="name" />
			{/* contact is managed in the CRM */}
			
			{agency.id !== C.newId && 
			<div>
				<a href={`#campaign?agencyId=${encURI(agency.id)}`}>View Campaigns</a> - <a href={`#advertiser?agencyId=${encURI(agency.id)}`}>View Brands</a>					
			</div>}

			<PropControl label="Notes" path={path} prop="notes" type="textarea" item={agency} />
			
			<BrandingEditor entity={agency} path={path} />

			<PaymentSettingsEditor item={agency} path={path} />

			<SavePublishDeleteEtc type={C.TYPES.Agency} id={agency.id} preDelete={() => confirm("Delete this Agency?")}/>
		</div>
	);
}


function PaymentSettingsEditor({item,path}) {
	const ppath = path.concat("paymentSettings");
	return (<Card title="Payment Settings">
		
		<PropControl path={path} prop="xero" label="Xero ID" placeholder="e.g. abc12345-ab12-34ab-ab12-12345abc" />
			{item && item.xero && <LinkOut href={getXeroContactUrl(item.xero)} >xero</LinkOut>}

		<PropControl path={ppath} prop="currency" type="select" label 
			options={Object.keys(Money.CURRENCY)} /* TODO refactor to use code from PropControlMoney */
		/>

		{/* FYI CPM should move to Deal objects eventually */}
		<PropControlMoney path={ppath} prop="measurementCPM" label="Measurement CPM"/>
		{item?.paymentSettings?.measurementCPM && item.paymentSettings.measurementCPM.currency !== item?.paymentSettings?.currency && <Alert color='warning'>Currency Mismatch</Alert>}
	</Card>);
}

export default AgencyPage;
